import {Directive, Renderer, ElementRef} from '@angular/core';

@Directive({
  selector: '[RestrictFocus]'
})
export class RestrictFocusDirective{
  constructor(public renderer: Renderer, public elementRef: ElementRef) {
  }
  elementInViewport2(el) {

    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
  }
  ngAfterViewInit(): void {

    if(!this.elementRef.nativeElement.elements || this.elementRef.nativeElement.elements.length == 0) return;
    var _self = this;
    for(var i=0; i< _self.elementRef.nativeElement.elements.length; i++){
      _self.elementRef.nativeElement.elements[i].index = i;
      _self.elementRef.nativeElement.elements[i].addEventListener('keydown', function(e){
        if(e.keyCode != 9) return;
        e.preventDefault();

        var next = this.index +1;
        if(next == _self.elementRef.nativeElement.elements.length) next = 0;

        while(_self.elementRef.nativeElement.elements[next].type == 'checkbox'
          || _self.elementRef.nativeElement.elements[next].offsetParent === null
          || _self.elementRef.nativeElement.elements[next].hidden
          || !_self.elementInViewport2(_self.elementRef.nativeElement.elements[next])
          || (_self.elementRef.nativeElement.elements[next].tagName == 'SELECT' && _self.elementRef.nativeElement.elements[next].offsetParent.className == 'ui-helper-hidden-accessible')
        || (_self.elementRef.nativeElement.elements[next].type == 'button' /* && _self.elementRef.nativeElement.elements[next].readOnly*/)
          || (_self.elementRef.nativeElement.elements[next].type == 'submit' /* && _self.elementRef.nativeElement.elements[next].readOnly*/)

          ){
          next = next +1;
          if(next == _self.elementRef.nativeElement.elements.length) next = 0;
        }

        _self.elementRef.nativeElement.elements[next].focus();
      });
    }

    setTimeout(function(){
      _self.elementRef.nativeElement.elements[0].focus();
    }, 200);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/directives/restrictFocus.directive.ts